var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feature-requests-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions-bar" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: {
                click: function ($event) {
                  _vm.showAddModal = true
                },
              },
            },
            [_vm._v("\n      Add Feature Request\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          staticClass: "tabs",
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "Top Votes", name: "votes" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "requests-list",
              },
              [
                _vm.featureRequests.length > 0
                  ? _vm._l(_vm.featureRequests, function (request) {
                      return _c("feature-request-card", {
                        key: request.id,
                        attrs: { request: request },
                      })
                    })
                  : _c("el-empty", {
                      attrs: { description: "No feature requests found" },
                    }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "Recent", name: "recent" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "requests-list",
              },
              [
                _vm.featureRequests.length > 0
                  ? _vm._l(_vm.featureRequests, function (request) {
                      return _c("feature-request-card", {
                        key: request.id,
                        attrs: { request: request },
                      })
                    })
                  : _c("el-empty", {
                      attrs: { description: "No feature requests found" },
                    }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalPages > 1
        ? _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  total: _vm.totalItems,
                  layout: "prev, pager, next, total",
                },
                on: { "current-change": _vm.handlePageChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("add-feature-request-modal", {
        attrs: { visible: _vm.showAddModal },
        on: {
          "update:visible": function ($event) {
            _vm.showAddModal = $event
          },
          created: _vm.handleFeatureRequestCreated,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("h1", [_vm._v("Feature Requests")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }